import axios from "axios";

export default {
  namespaced: true,
  state: {
    top10: null,
    average: null
  },
  mutations: {
    setTop10(state, data) {
      state.top10 = data;
    },
    setAverage(state, data) {
      state.average = data;
    }
  },
  actions: {
    async fetchTop10({ state, commit }) {
      if (state.top10) return state.top10;
      const response = await axios.get("/api/player_tournaments/leaders/getTop10Players");
      commit("setTop10", response.data);
      return response.data;
    },
    async fetchAverage({ state, commit }) {
      if (state.average) return state.average;
      const response = await axios.get("/api/player_tournaments/leaders/getAverage");
      commit("setAverage", response.data);
      return response.data;
    }
  }
}